import { render, staticRenderFns } from "./registerComponent.vue?vue&type=template&id=61f47d8f&scoped=true"
import script from "./registerComponent.vue?vue&type=script&lang=js"
export * from "./registerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f47d8f",
  null
  
)

export default component.exports